export const UPDATE_B2B_MIS_SUCCESS = "UPDATE_B2B_MIS_SUCCESS";
export const UPDATE_B2B_MIS_REQUEST = "UPDATE_B2B_MIS_REQUEST";
export const UPDATE_B2B_MIS_FAILURE = "UPDATE_B2B_MIS_FAILURE";
export const UPDATE_B2B_MIS_RESET = "UPDATE_B2B_MIS_RESET";
export const updateB2BMisSuccess = (payload) => ({
    type: UPDATE_B2B_MIS_SUCCESS,
    payload,
});
export const updateB2BMisRequest = (payload) => ({
    type: UPDATE_B2B_MIS_REQUEST,
    payload,
});
export const updateB2BMisFailure = (payload) => ({
    type: UPDATE_B2B_MIS_FAILURE,
    payload,
});
export const updateB2BMisReset = () => ({
    type: UPDATE_B2B_MIS_RESET,
});
